export default __webpack_public_path__ + "static/media/address.0059745a.svg";